import { ReactNode } from 'react';
import { Card, CardBody, CardHeader, Text } from '@backstage/ui';
import styles from './ModernCustomCard.module.css';

interface CustomCardNewProps {
  children: ReactNode;
  title: string;
  actions?: ReactNode;
}

export function ModernCustomCard(props: Readonly<CustomCardNewProps>) {
  const { children, title, actions } = props;

  return (
    <Card className={styles.card}>
      <CardHeader className={styles.header}>
        <div className={styles.headerContent}>
          <Text variant="title-small" weight="bold">
            {title}
          </Text>
          {actions}
        </div>
      </CardHeader>
      <CardBody className={styles.body}>{children}</CardBody>
    </Card>
  );
}
